import { BufferUtil } from "@solomon-labs/buffer";
import { MEMO_PROGRAM_ID_STRING } from "@solomon-labs/constants";
import { PublicKey } from "@solomon-labs/publickey";
import { type IsEncodable, SystemTransferInstruction } from "@solomon-labs/solana-codec";
import { Transaction } from "@solomon-labs/solana-transactions";
import type { SolanaBlockhash } from "@solomon-labs/types";

/** Keep legacy transfers unchanged; position verification adds a signer-bound nonce memo. */
export function buildClientVerificationTransfer(args: {
    payer: PublicKey;
    recipient: PublicKey;
    blockhash: SolanaBlockhash;
    memo?: string;
}): Transaction {
    const transaction = new Transaction()
        .setFeePayer(args.payer)
        .setRecentBlockhash(args.blockhash)
        .add(new SystemTransferInstruction({ from: args.payer, to: args.recipient, lamports: 1000n }));
    if (args.memo !== undefined) {
        if (!/^solomon-yaas:v1:[a-f0-9]{64}$/.test(args.memo))
            throw new Error("Invalid position verification transfer memo");
        const memo = {
            programId: new PublicKey(MEMO_PROGRAM_ID_STRING),
            accounts: [{ pubkey: args.payer, isSigner: true, isWritable: false }],
            data: BufferUtil.fromString(args.memo, "utf8")
        };
        const instruction: IsEncodable = {
            programId: memo.programId,
            encode: () => memo.data,
            accounts: () => memo.accounts,
            instruction: () => memo
        };
        transaction.add(instruction);
    }
    return transaction;
}
